module.exports = __webpack_public_path__ + "img/19 Animation 2-squashed.01dd87d7.jpg";